<template>
  <div id="delivery" class="container">
    <SfBreadcrumbs
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs"
    />

    <OrkLoader :loading="loading">
      <h2 v-if="error && !content" class="error-msg">{{ $t('serviceUnavailable') }}</h2>
      <div v-else-if="content" class="delivery">
        <SfHeading :level="1"
                   :title="content.marketing_delivery_title"
                   class="sf-heading--left">
        </SfHeading>
        <div class="content" v-html="content.marketing_delivery_content"></div>

      </div>
    </OrkLoader>
  </div>
</template>

<script>
import {SfBreadcrumbs, SfHeading} from "@storefront-ui/vue"
import Api from '@/api/Api';
import {OrkLoader} from "@/components/Ork";

export default {
  name: "Delivery",
  components: {
    SfHeading,
    OrkLoader,
    SfBreadcrumbs
  },
  data() {
    return {
      breadcrumbs: null,
      loading: false,
      error: false,
      content: null,
    }
  },
  created() {
    this.setBreadcrumbs();
    this.getContent();
  },
  methods: {
    setBreadcrumbs() {

      this.breadcrumbs = [{
        text: this.$i18n.t('Home'),
        link: '/'
      }, {
        text: this.$i18n.t('Delivery'),
      }];

    },
    getContent() {
      this.loading = true;
      Api.marketing.getDelivery()
          .then((data) => {
            this.content = data;

          })
          .catch((err) => {
            this.error = true;
          }).finally(this.loading = false)
    }
  },
}
</script>

<style lang="scss" scoped>
.error-msg {
  text-align: center;
}
</style>